<template>
  <v-app>
    <v-app-bar app v-if="$route.name && !$store.getters['auth/routeIsPublic']($route) && !$route.meta.hideAppBar">
      <a
        class="d-block text--primary py-sm-1"
        style="height: 100%;"
        href="#/"
      >
        <img
          ref="logo"
          :src="'../web/app-logo'"
          @error="
            () =>{
              this.$refs.logo.onerror = null;
              this.$refs.logo.src = this.src=require('./assets/ic_digierge_logo.png')
            }
          "
          alt="DIGIERGE"
          style="max-width: 140px; height: 100%; object-fit: contain; image-rendering: -webkit-optimize-contrast;"
        >
      </a>

      <v-btn text class="ml-5" to="/"><v-icon left>mdi-home-outline</v-icon>{{ $t('digierge.app-bar.home') }}</v-btn>

      <v-spacer/>

      <LanguageSelector class="mx-2"></LanguageSelector>

      <a
        class="d-block py-1"
        style="height: 100%;"
        href="https://www.wip.se"
        target="_blank"
        v-if="$vuetify.breakpoint.smAndUp"
      >
        <img
          :src="require('./assets/poweredby_logos_text.svg')"
          alt="Powered by DIGIERGE | WIP"
          style="filter: brightness(0.4); max-width: 180px; height: 100%; object-fit: contain; image-rendering: -webkit-optimize-contrast;"
        >
      </a>
    </v-app-bar>

    <v-main class="ma-4">
      <div class="mb-4">
        <Breadcrumbs v-if="$route.name && !$store.getters['auth/routeIsPublic']($route) && !$route.meta.hideAppBar"></Breadcrumbs>
      </div>
      <div v-if="$route.name == 'login'"
        class="d-flex flex-column align-center my-8">
        <img
          ref="logo"
          :src="'../web/app-logo'"
          @error="
            () =>{
              this.$refs.logo.onerror = null;
              this.$refs.logo.src = this.src=require('./assets/ic_digierge_logo.png')
            }
          "
          alt="DIGIERGE"
          style="max-width: 180px; height: 100%; object-fit: contain; image-rendering: -webkit-optimize-contrast;"
        >
      </div>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { Breadcrumbs } from 'dync-web';
import { LanguageSelector } from 'dync-messages';

export default {
  name: 'App',
  components: {
    Breadcrumbs,
    LanguageSelector
  },
  data () {
    return {
      //
    }
  },
  created() {
    if (this.$store.getters['dync-properties/get']('digierge', 'web_home_title')) {
      document.title = this.$t(
        this.$store.getters['dync-properties/get']('digierge', 'web_home_title'),
        { procentPrefix: true }
      );
    }
  }
}
</script>
